import { render, staticRenderFns } from "./itemUploadAudio.vue?vue&type=template&id=cefed5e2&scoped=true&"
import script from "./itemUploadAudio.vue?vue&type=script&lang=js&"
export * from "./itemUploadAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefed5e2",
  null
  
)

export default component.exports